// extracted by mini-css-extract-plugin
module.exports = {"card-summary":"card-summary__3hYYM","first-header":"first-header__3GoFY"};